import React, {Component} from 'react'
import {Modal} from 'react-bootstrap'
import CreateGroupForm from './CreateGroupForm'
import {createGroup} from '../../../actions/index'
import { SubmissionError } from 'redux-form'

export default class CreateGroupModal extends Component {

    onCancel = (e) => {
        e.preventDefault();
        this.props.onCancel();
    }

    handleSubmit = (values) => {
        console.log('handleSubmit', values)

        if (!values.name) {
            throw new SubmissionError({ _error: 'Fill out all the fields' })
        }

        this.props.dispatch(createGroup(values))
        this.props.onCancel();
    }

    render() {
        return <div className="vertical-alignment-helper">
            <div className="modal-dialog vertical-align-center">
                <Modal.Dialog>
                    <Modal.Header>
                        <Modal.Title>CREATE NEW MAINTENANCE AGENCY</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <CreateGroupForm onCancel={this.onCancel} onSubmit={this.handleSubmit} />
                    </Modal.Body>

                    <div className="green-bottom" />
                </Modal.Dialog>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/groups/CreateGroupModal.jsx